import { render, staticRenderFns } from "./addTax.vue?vue&type=template&id=bf37420e"
import script from "./addTax.vue?vue&type=script&lang=js"
export * from "./addTax.vue?vue&type=script&lang=js"
import style0 from "./addTax.vue?vue&type=style&index=0&id=bf37420e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports